import React, { Component } from 'react';
import { css } from 'aphrodite/no-important';
import { styles } from './AlertEndStyles';

export default class AlertEnd extends Component {
  render() {
    return (
        <div className={css(styles.endWrapper)}>
          {this.props[0] && <span className={css(styles.leftSide)}/>}
          <span className={css(styles.rightSide)}>{`~ No ${this.props[0] ? 'more' : ''} alerts to show ~`}</span>
        </div>
    );
  }
}
